const submitRoiCalculator1233FormWithOutputUrl = require("../../run/roiCalculator/submitRoiCalculator1233FormWithOutputUrl");
const setRoiCalculatorDownloadLink = require("../../run/roiCalculator/setRoiCalculatorDownloadLink");
const showRoiCalculatorDialogSuccessStep = require("../../run/roiCalculator/showRoiCalculatorDialogSuccessStep");
const cancelRoiCalculatorLoadingTimeout = require("../../run/roiCalculator/cancelRoiCalculatorLoadingTimeout");

/**
 * @param outputUrl {string}
 * @param roiCalculatorLoadingTimeout {RoiCalculatorTimeout}
 * @return {void}
 */
module.exports = function whenRoiCalculatorOutputUrlEvent(outputUrl, roiCalculatorLoadingTimeout) {
    void submitRoiCalculator1233FormWithOutputUrl(outputUrl);
    setRoiCalculatorDownloadLink(outputUrl);
    showRoiCalculatorDialogSuccessStep();
    cancelRoiCalculatorLoadingTimeout(roiCalculatorLoadingTimeout.timeoutId);
}
